// One-time credentials (provisioning + password resets) are shown in a modal
// dialog with copy buttons — NOT a toast — because the backend never shows
// them again and the admin needs to reliably copy + hand them over.
//
// Call sites keep using showCredentials(res); it forwards to the dialog host
// (CredentialsDialog) mounted once at the app root. Returns true when
// credentials were present (so callers can fall back to a plain success
// toast when they weren't).

let opener = null;

// Registered by the mounted <CredentialsDialog /> host.
export function registerCredentialsDialog(fn) {
  opener = fn;
}

export function showCredentials(res) {
  const creds = res?.credentials;
  if (!creds?.temp_password) return false;

  if (opener) {
    opener({ username: creds.username, password: creds.temp_password });
  }
  return true;
}
